// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"search_pageTitle__ZycxR","csTeamSearchSearchBackground":"search_csTeamSearchSearchBackground__1bVy0","csTeamSearchSiteWidth":"search_csTeamSearchSiteWidth__38jrN"};